import { PageHeader } from "@/components/ui-bits";
import { InsightsPanel } from "@/components/InsightsPanel";

export default function MoneyStuck() {
  return (
    <div data-testid="money-stuck-page">
      <PageHeader title="RecoveryOS Insights" subtitle="Know What Is Stuck. Know What To Do Next." />
      <InsightsPanel />
    </div>
  );
}
